import request from '@/utils/request'

// 查询列表
export function selectPage(query) {
  return request({
    url: "/cw/income/getPage",
    method: "get",
    params: query
  });
}

// 删除
export function delData(id) {
  return request({
    url: "/cw/income/"+id,
    method: "delete"
  });
}

// 根据id查询
export function selectOne(id) {
  return request({
    url: "/cw/income/"+id,
    method: "get"
  });
}

// 新增
export function addData(data) {
  return request({
    url: "/cw/income",
    method: "post",
    data: data
  });
}

// 修改
export function updateData(data) {
  return request({
    url: "/cw/income",
    method: "put",
    data: data
  });
}

// 设为默认/取消
export function changeStatus(incomeId) {
  return request({
    url: "/cw/income/"+incomeId,
    method: "put"
  });
}
